(function () {

    angular
        .module('smartertoolsApp')
        .factory('userPartnerService', ['$http', 'refreshToken', '$log', 'cacheControl', userPartnerService]);

    function userPartnerService($http, refreshToken, $log, cacheControl) {
        const urlBase = apiRootUrl;

        return {
            clearCachedItems: clearCachedItems,
            getPartnershipDetails:getPartnershipDetails
        };

        // -----------------------------------------------

        function clearCachedItems() {
            cacheControl.getCache('myAccountCache').remove('v1/account/partnership-details');
        }

        function getPartnershipDetails() {
            return refreshToken.refreshToken()
                .then(function () {
                    return $http.get(`${urlBase}v1/account/partnership-details`, {cache: cacheControl.getCache('myAccountCache')});
                })
                .then(function (response) {
                    return response.data;
                });
        }
    }

})();